import { css } from 'lit';
export default css `
  :host {
    width: 100%;
    display: block;
  }
`;
//# sourceMappingURL=styles.js.map